import { FilterModifier } from "./FilterModifier"

export const NullableBooleanEqualsFilterModifier = FilterModifier.create<boolean | null, boolean | null>({
	id: "nullable-boolean-equals",
	getApplyFn: (filterValue) => (value) => value === filterValue,
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const BooleanNotEqualsFilterModifier = FilterModifier.create<boolean | null, boolean | null>({
	id: "nullable-boolean-not-equals",
	getApplyFn: (filterValue) => (value) => value !== filterValue,
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
